var map = {
	"./admin_settings.png": 1432,
	"./catalog.png": 1433,
	"./catalog_order.png": 1434,
	"./cms.png": 1435,
	"./component-fields/Asset.png": 1436,
	"./component-fields/Blocks.png": 1437,
	"./component-fields/Boolean.png": 1438,
	"./component-fields/Date-time.png": 1439,
	"./component-fields/LInk.png": 1440,
	"./component-fields/Markdown.png": 1441,
	"./component-fields/Multi asset.png": 1442,
	"./component-fields/Multi options.png": 1443,
	"./component-fields/Number.png": 1444,
	"./component-fields/Richtext.png": 1445,
	"./component-fields/Single options.png": 1446,
	"./component-fields/Table.png": 1447,
	"./component-fields/Text area.png": 1448,
	"./component-fields/Text.png": 1449,
	"./components.png": 1450,
	"./configuration.png": 1451,
	"./contents.png": 1452,
	"./custom_order.png": 1453,
	"./customer_credits.png": 1454,
	"./dashboard.png": 1455,
	"./dashboard_available_credit.png": 1456,
	"./dashboard_due_soon.png": 1457,
	"./dashboard_invoices.png": 1458,
	"./dashboard_market.png": 1459,
	"./dashboard_messages.png": 1460,
	"./dashboard_new_arrivals.png": 1326,
	"./dashboard_new_catalog_order.png": 1321,
	"./dashboard_new_custom_order.png": 1323,
	"./dashboard_new_estimate.png": 1322,
	"./dashboard_new_payment.png": 1325,
	"./dashboard_new_repair.png": 1324,
	"./dashboard_orders.png": 1461,
	"./dashboard_past_due.png": 1462,
	"./dashboard_quotes.png": 1463,
	"./dashboard_sales_orders.png": 1464,
	"./dashboard_total_payable.png": 1465,
	"./estimate.png": 1466,
	"./financials.png": 1467,
	"./home.png": 1468,
	"./invoices.png": 1469,
	"./media_library.png": 1470,
	"./move.png": 1471,
	"./order_creation.png": 1472,
	"./orders.png": 1473,
	"./payment-methods/amex.png": 1168,
	"./payment-methods/discover.png": 1172,
	"./payment-methods/mastercard.png": 1173,
	"./payment-methods/visa.png": 1174,
	"./payment.png": 1474,
	"./product_catalog.png": 1475,
	"./products.png": 1476,
	"./quote-icon.png": 1477,
	"./quotes.png": 1478,
	"./quotes_approve.png": 1479,
	"./repair_order.png": 1480,
	"./sales_orders.png": 1481,
	"./status_tracking.png": 1482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1215;